import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { CanActivateChildGuard } from 'src/app/core/guards/can-activate-child.guard';
import { CreateReportComponent } from './create-report/create-report.component';
import { ListReportComponent } from './list-report/list-report.component';

const routes: Routes = [
  {
    path: '',
    component: ListReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./list-report/list-report.module').then(m => m.ListReportModule),
  },
  {
    path: 'create',
    component: CreateReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./create-report/create-report.module').then(m => m.CreateReportModule)
  },
  {
    path: 'create/:id',
    component: CreateReportComponent,
    canActivate: [
      AuthGuard,
      CanActivateChildGuard
    ],
    loadChildren: () => import('./create-report/create-report.module').then(m => m.CreateReportModule)
  },
  {
    path: 'view/:id/:isView',
    canActivate: [AuthGuard, CanActivateChildGuard],
    loadChildren: () => import('./view-report-detail/view-report-detail.module').then(m => m.ViewReportDetailModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenuExportReportRoutingModule { }
